import { render } from "./OrphanedMessages.vue?vue&type=template&id=0b1c1fe4&ts=true"
import script from "./OrphanedMessages.vue?vue&type=script&lang=ts"
export * from "./OrphanedMessages.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__